const RUNWAY_API_URL =
  "https://api.runwayml.com/v1/inference/stable-video-diffusion";

const API_KEY = process.env.REACT_APP_RUNWAY_API_KEY;

// console.log("runway_api는 ", API_KEY);

export const generateVideoFromImage = async (imageUrl) => {
  try {
    const response = await fetch(RUNWAY_API_URL, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${API_KEY}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        input: {
          image: imageUrl,
          motion: "medium",
          seed: 42,
        },
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Runway API 응답 상태:", response.status);
      console.error("Runway API 응답 내용:", errorText);
      throw new Error("Runway API 호출 실패");
    }

    return await response.json();
  } catch (err) {
    console.error("Runway API 오류:", err);
    throw err;
  }
};
